import { capitalize, join, split } from 'lodash';

export default function formatStatus(status) {
  return capitalize(join(split(status, '_'), ' '));
}
